import React from 'react';

function PricingToggle({ periods, activePeriod, onPeriodChange }) {
  return (
    <div className="career-pricing-toggle pills" role="tablist" aria-label="Pricing period selector">
      {periods.map((period) => {
        const isActive = period.id === activePeriod;

        return (
          <button
            key={period.id}
            type="button"
            className={`pill career-pricing-toggle__button ${isActive ? 'active is-active' : ''}`}
            onClick={() => onPeriodChange(period.id)}
            role="tab"
            aria-selected={isActive}
          >
            <span>{period.label}</span>
            {period.badge ? <small>{period.badge}</small> : null}
          </button>
        );
      })}
    </div>
  );
}

export default PricingToggle;